import { createContext } from "preact";
const initialValue = {
    locale: "pl",
};
const ctx = createContext(initialValue);
export default ctx;
